module.exports = __webpack_public_path__ + "img/symbol_9.6a0b6eb5.png";